<mat-menu #menu="matMenu" class="oxanium-medium">
  <button mat-menu-item [matMenuTriggerFor]="creator">Creator</button>
  <button mat-menu-item [matMenuTriggerFor]="view">View</button>
</mat-menu>

<mat-menu #view="matMenu" class="oxanium-medium text-color-primary">
    @switch (viewSteps) {
        @case (0) {
            <button class="menu-item" mat-menu-item (click)="removeNodeView($event)">Remove from View (and childs)</button>
            <button class="menu-item" mat-menu-item (click)="removeNodeViewKeepChildren($event)">Remove only this from View (keep childs)</button>
            <button class="menu-item" mat-menu-item (click)="onContainer($event)">Make a View of this Container</button>
        }
        @case (1) {
            <span class="fw-5 text-color-primary oxanium-medium">Enter View Name:</span>
            <div>
                <input matInput class="oxanium-medium" placeholder="name" (click)="preventPropagation($event)" [(ngModel)]="nodeName">
            </div>
            <div class="d-flex justify-content-end">
                <mat-icon class="me-3" color="warn" (click)="onClose($event)">close</mat-icon>
                <mat-icon color="done" color="primary" (click)="onCreateView($event)">done</mat-icon>
            </div>
        }
        @case (2) {
            <span class="fw-5 oxanium-medium text-color-primary">Are you sure to Remove the node and its childrens?</span>
            <div class="d-flex justify-content-end">
                <mat-icon class="me-3" color="warn" (click)="onClose($event)">close</mat-icon>
                <mat-icon color="done" color="primary" (click)="onRemoveFromView($event)">done</mat-icon>
            </div>
        }
        @case (3) {
            <span class="fw-5 oxanium-medium text-color-primary">Are you sure to Remove only this the node? (keep the children outside)</span>
            <div class="d-flex justify-content-end">
                <mat-icon class="me-3" color="warn" (click)="onClose($event)">close</mat-icon>
                <mat-icon color="done" color="primary" (click)="onRemoveOnlyThisFromView($event)">done</mat-icon>
            </div>
        }
    }
    
</mat-menu>

<mat-menu class="matMenu" #creator="matMenu">
    <div class="menu"(click)="preventPropagation($event)">
    <!-- <div class="menu" #menu="cdkMenu" cdkMenu> -->
        @switch (stepNumber) {
            @case(1){
                @if(selectedRelation.getConnection()){
                    <button class="menu-item" mat-menu-item (click)="stepNumber = 7">Delete Relation</button>
                }@else if (selectedShape.getShape()[0]){
                    <button class="menu-item" mat-menu-item (click)="onAddNode($event)">Add Node</button>
                    @if (canDeleteNode()) {
                        <button class="menu-item" mat-menu-item (click)="onDeleteNode($event)">Delete Node</button>
                        <button class="menu-item" mat-menu-item (click)="onConnetion($event)">Make a Connection</button>
                    }
                    <!-- <button class="menu-item" mat-menu-item (click)="onContainer($event)">Make a View of this Container</button> -->
                }
            }
            @case(2){
                <span class="fw-5 oxanium-medium">Select Relation Type</span>
                <mat-chip-listbox [(ngModel)]="relationType" class="chip-list">
                    @for (relation of document.connection.DBrelations; track relation) {
                        <mat-chip-option color="primary" (click)="onNode($event)">{{relation}}</mat-chip-option>
                    }
                </mat-chip-listbox>
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <span class="fw-5 oxanium-medium">Enter New Relation Name:</span>
                    <div>
                        <input matInput placeholder="name" (click)="preventPropagation($event)" [(ngModel)]="relationType">
                    </div>
                    <div class="d-flex justify-content-end w-100">
                        <mat-icon class="me-3" color="warn" (click)="onClose($event)">close</mat-icon>
                        <mat-icon color="done" color="primary" (click)="onNode($event)">done</mat-icon>
                    </div>
                </div>
            }
            @case(3){
                <span class="fw-5 oxanium-medium">Select Label Type</span>
                <mat-chip-listbox [(ngModel)]="labelName" class="chip-list">
                    @for (label of document.connection.DBlabels; track label; let index = $index) {
                        <mat-chip-option color="primary" (click)="onChip($event)">{{label}}</mat-chip-option>
                    }
                </mat-chip-listbox>
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <span class="fw-5 oxanium-medium">Enter New Label Name:</span>
                    <div>
                        <input matInput placeholder="name" (click)="preventPropagation($event)" [(ngModel)]="labelName">
                    </div>
                    <div class="d-flex justify-content-end w-100">
                        <mat-icon class="me-3" color="warn" (click)="onClose($event)">close</mat-icon>
                        <mat-icon color="done" color="primary" (click)="onChip($event)">done</mat-icon>
                    </div>
                </div>
            }
            @case(4){
                <span class="fw-5 oxanium-medium">Enter Node Name:</span>
                <div>
                    <input matInput placeholder="name" class="oxanium-medium" (click)="preventPropagation($event)" [(ngModel)]="nodeName">
                </div>
                <div class="d-flex justify-content-end">
                    <mat-icon class="me-3" color="warn" (click)="onClose($event)">close</mat-icon>
                    <mat-icon color="done" color="primary" (click)="onCreateNode($event)">done</mat-icon>
                </div>
            }
            @case(5){
                <span class="fw-5 oxanium-medium">Are you sure to delete the node {{selectedShape.getShape()[0].name}}?</span>
                <div class="d-flex justify-content-end">
                    <mat-icon class="me-3" color="warn" (click)="onClose($event)">close</mat-icon>
                    <mat-icon color="done" color="primary" (click)="deleteNode($event)">done</mat-icon>
                </div>
            }
            <!-- @case(6){
                <span class="fw-5">Enter View Name:</span>
                <div>
                    <input matInput placeholder="name" (click)="preventPropagation($event)" [(ngModel)]="nodeName">
                </div>
                <div class="d-flex justify-content-end">
                    <mat-icon class="me-3" color="warn" (click)="onClose($event)">close</mat-icon>
                    <mat-icon color="done" color="primary" (click)="onCreateView($event)">done</mat-icon>
                </div>
            } -->
            @case(7){
                <span class="fw-5 oxanium-medium">Are you sure to delete the relation?</span>
                <div class="d-flex justify-content-end">
                    <mat-icon class="me-3" color="warn" (click)="onClose($event)">close</mat-icon>
                    <mat-icon color="done" color="primary" (click)="deleteRelation($event)">done</mat-icon>
                </div>
            }
        }
    </div>
<!-- </div> -->
</mat-menu>
<button mat-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" style="display: none;"></button>